import React from "react"

const SaveIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 22 22">
    <g fill="none" fillRule="evenodd">
      <polygon points="6 4 6 16.498 10.39 12.653 14.781 16.498 14.781 4" stroke="#979797" strokeWidth="1.5" />
    </g>
  </svg>
)

export default SaveIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/SaveIcon.jsx